export default "__VITE_ASSET__B_xvb98L__"